import { Box, BoxProps } from '@bitrise/bitkit';

export type PageProps = BoxProps;

const Page = (props: PageProps): JSX.Element => {
  return <Box display="flex" flexDirection="column" minHeight="100%" {...props} />;
};

export default Page;
